<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Logística</mat-card-title>
      <button class="btn-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
  </mat-card-header>
  <div>
    <div class="mt-6 mb-4">
      <mat-card class="card-style shadow px-4 py-6 mb-4">
        <div class="flex w-full justify-between gap-2 mt-4">
          <div class="w-1/12"><strong class="text-gray-700 font-bold">Tg:</strong> {{ data.codigoTg }}</div>
          <div class="w-2/12">
            <strong class="text-gray-700 font-bold">Evento:</strong>
            {{ data.nomeEvento }}
          </div>
          <div class="w-9/12">
            <strong class="text-gray-700 font-bold">Início:</strong> {{ data.dataInicio }} <strong class="text-gray-700 font-bold">Fim:</strong> {{ data.dataFim }}
          </div>
        </div>
        <div class="flex w-full justify-between gap-2 mt-4">
          <div class="w-6/12">
            <strong class="text-gray-700 font-bold">{{ data.nomeSubCliente && data.nomeSubCliente != '' ? 'Subcliente' : 'Cliente' }}:</strong>
            {{ data.nomeSubCliente && data.nomeSubCliente != '' ? data.nomeSubCliente : data.nomeCliente }}
          </div>
        </div>
        <div class="flex w-full justify-between gap-2 mt-4">
          <div class="w-4/12"><strong class="text-gray-700 font-bold">Solicitante:</strong> {{ data.nomeConsultor }}</div>
          <div class="w-4/12"><strong class="text-gray-700 font-bold">Consultor comercial:</strong> {{ data.consultorComercial }}</div>
          <div class="w-4/12"><strong class="text-gray-700 font-bold">Consultor operacional:</strong> {{ data.nomeConsultorOperacional }}</div>
        </div>
      </mat-card>
    </div>
    <div class="mt-4">
        <mat-tab-group animationDuration="400ms">
      <mat-tab label="Passageiros">
      <logistics-passengers [data]="data"></logistics-passengers>
      </mat-tab>
          <mat-tab label="Itens Proposta">
        <logistics-item-proposal [data]="data"></logistics-item-proposal>
          </mat-tab>
          <mat-tab label="Itens Logística">
            <logistics-item-logistic [data]="data"></logistics-item-logistic>
          </mat-tab>
        </mat-tab-group>
    </div>
  </div>
</mat-card>
